export default __webpack_public_path__ + "static/media/icons-mail-navigation-black.14146fa6.svg";